import React from 'react';
import styles from "./SuggestionsPatientsListComponent.module.scss";
import ProgressBar from 'components/ui_components/ProgressBar/ProgressBar'
import StyledCheckbox from 'components/ui_components/StyledCheckbox/StyledCheckbox.js';
import FormControlLabel from '@mui/material/FormControlLabel';

const SuggestionsPatientsListComponent = props => {
    const {isNewPatient, handleNewPatientCheck, dataLoading, patientsData, handleClickSuggestedPatient} = props;

    return (
        <div className={styles.suggestionsPatients}>
            <FormControlLabel
                className={styles.newPatientCheckbox}
                control={<StyledCheckbox
                checked={isNewPatient}
                onChange={handleNewPatientCheck}
                value="checked"
                inputProps={{ tabIndex: -1 }}
            />}
                label="New Patient (hide suggestions)"
            />

            <div className={styles.suggestionsPatientsHeader}>
                Suggested Patients list
            </div>

            {!isNewPatient &&
            <ul className={styles.suggestionsPatientsList} role="listbox">
                {dataLoading && <ProgressBar/>}
                {patientsData.map(patient => {
                    let dob = '';
                    if (patient.patientDobMonth && patient.patientDobDate && patient.patientDobYear) {
                        dob = `${('0' + patient.patientDobMonth).slice(-2)}/${('0' + patient.patientDobDate).slice(-2)}/${patient.patientDobYear}`;
                    } else if (patient.patientDob) {
                        const date = new Date(patient.patientDob);
                        if (!isNaN(date)) {
                            const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
                            const dd = String(date.getUTCDate()).padStart(2, '0');
                            const yyyy = date.getUTCFullYear();
                            dob = `${mm}/${dd}/${yyyy}`;
                        }
                    }

                    const handleKeyDown = (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleClickSuggestedPatient(patient);
                        } else if (e.key === 'ArrowDown') {
                            e.preventDefault();
                            const next = e.target.nextElementSibling;
                            if (next) next.focus();
                        } else if (e.key === 'ArrowUp') {
                            e.preventDefault();
                            const prev = e.target.previousElementSibling;
                            if (prev) prev.focus();
                        }
                    };

                    return <li 
                               key={patient.id}
                               tabIndex={0}
                               role="option"
                               aria-selected={false}
                               onClick={handleClickSuggestedPatient.bind(this, patient)}
                               onKeyDown={handleKeyDown}
                           >
                        {patient.patientLastName} {patient.patientFirstName} {patient.patientMiddleName}, {dob}, {patient.patientGenderDesc}
                    </li>
                })}
            </ul>
            }
        </div>
    );
}

export default SuggestionsPatientsListComponent;